// extracted by mini-css-extract-plugin
module.exports = {"root":"SubmitRequest_root__3t29c","title":"SubmitRequest_title__3iu6G","submitBtn":"SubmitRequest_submitBtn__2FxdW","rtlSubmitInfoImage":"SubmitRequest_rtlSubmitInfoImage__Avnnm"};